import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Stack,
  Inline,
  Divider,
  IconButton,
  IconShoppingBag24,
  Text,
  LogoBrand2024Navy,
  IconArrowLeft24,
} from '@stitch-fix/mode-react';

import styles from './styles.module.scss';

const BagHeader = ({ bagCount }) => {
  return (
    <Box>
      <Stack>
        <nav className={styles['bag-header-wrapper']}>
          <IconButton
            aria-label="Back"
            onClick={() => {
              window.history.back();
            }}
            ml={{ sm: '-0.5rem', lg: '-1rem' }}
          >
            <IconArrowLeft24 />
          </IconButton>
          <LogoBrand2024Navy title="Stitch Fix" className={styles.logo} />
          <Stack hAlign="center">
            <Inline vAlign="center">
              <Box style={{ position: 'relative' }}>
                <IconShoppingBag24
                  title="Shopping bag icon"
                  className={styles.icon}
                  color="blue-45"
                />
                {bagCount !== 0 && (
                  <Box className={styles['items-count-container']}>
                    <Text
                      height="short"
                      family="medium"
                      scale="1"
                      color="blue-45"
                    >
                      {bagCount}
                    </Text>
                  </Box>
                )}
              </Box>
              <Box display={{ sm: 'none', md: 'block' }} ml="0.5rem">
                <Text height="short" family="regular" scale="3" color="blue-45">
                  Bag
                </Text>
              </Box>
            </Inline>
          </Stack>
        </nav>
        <Divider variant="subtle" />
      </Stack>
    </Box>
  );
};

BagHeader.propTypes = {
  bagCount: PropTypes.number.isRequired,
};

export default BagHeader;
